import { MonitorIcon, MoonIcon, SunIcon, type LucideIcon } from "lucide-react";

import type { ThemeMode } from "./types";

export const THEME_OPTIONS: {
  value: ThemeMode;
  label: string;
  icon: LucideIcon;
  description: string;
}[] = [
  {
    value: "system",
    label: "System",
    icon: MonitorIcon,
    description: "Follow your device preference",
  },
  { value: "light", label: "Light", icon: SunIcon, description: "Warm beige, always on" },
  { value: "dark", label: "Dark", icon: MoonIcon, description: "Dark charcoal, always on" },
];
